import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import LoginPage from "./pages/LoginPage";
import AdminHomePage from "./pages/AdminHomePage";
import UserHomePage from "./pages/UserHomePage";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicAssetPage from "./pages/PublicAssetPage";
import PublicLocationPage from "./pages/PublicLocationPage";
import ScanHandlerPage from "./pages/ScanHandlerPage";
import SignUpPage from "./pages/SignUpPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";

const App = () => {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <Routes>

            {/* Route for the login page (accessible by everyone) */}
            <Route path="/" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />

            {/* Route for the admin homepage, wrapped with ProtectedRoute to restrict access */}

            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminHomePage />
                </ProtectedRoute>
              }
            />

            {/* Route for the user homepage, wrapped with ProtectedRoute to restrict access */}

            <Route
              path="/user"
              element={
                <ProtectedRoute requiredRole="user">
                  <UserHomePage />
                </ProtectedRoute>
              }
            />
            {/* Route for public asset page, accessible by anyone */}

            <Route path="/public/assets/:assetId" element={<PublicAssetPage />} />
            <Route path="/public/locations/:containerId" element={<PublicLocationPage />} />
            <Route path="/scan/:token" element={<ScanHandlerPage />} />
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            className="custom-toast-container"
            toastClassName="custom-toast"
          />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
